import axios from "axios";
import { PortalSpendBusinessAccountResponse } from "redmond";
import { cobtBusinessPrefix } from "../../paths";
import { config } from "../../config";

const END_POINT: string = `${cobtBusinessPrefix}/accounts/context`;

export const fetchBusinessAccountContext = (): Promise<number | null> =>
  axios
    .get<PortalSpendBusinessAccountResponse>(END_POINT, {
      baseURL: config.baseURL,
      params: { select: "ACTIVEOFFERPORTALSPEND" },
    })
    .then((res) => res.data.onPortalSpendAmountDuringActiveOffer ?? null);

